export default "__VITE_ASSET__XjIO7rex__"